import BaseModel from "../core/BaseModel";

export default class ZoneModel extends BaseModel {
  constructor() {
    super(
      {
        name: "zone",
        tableName: "zone",
        label: "Quản lý khu vực",
        display_key: "name",
        default_order: { key: "created_at", direction: "asc" },
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        name: {
          name: "name",
          type: "TEXT",
          label: "Tên khu vực",
          sortable: false,
          filter: { type: "input", match: "contains" },
        },
        active: {
          name: "active",
          type: "Selection",
          custom: "SelectionText",
          label: "Hiển thị",
          class: "center",
          width: 6,
          options: [
            { label: "Hiển thị", value: true },
            { label: "Ẩn", value: false },
          ],
          filter: { type: "select", optionLabel: "label", optionKey: "value", match: "equals" },
        },
        updated_by: {
          name: "updated_by",
          type: "TEXT",
          label: "Người cập nhật",
          width: 10,
        },
        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối",
          width: 10,
        },
        created_at: {
          name: "created_at",
          type: "Datetime",
          label: "Ngày tạo",
          filter: { type: "DateRange", match: "contains" },
          display: false,
        },
      }
    );
  }
}
